import { action } from "typesafe-actions";
import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../initialStoreState";
import { api, whatsappApi } from "../../api/api";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../messages/messagesActions";

import { uploadMultipleFile } from "../../components/FileUpload/utils";
import {
  IWhatsAppTemplate,
  IWhatsAppTemplateData,
  IWhatsAppTemplatePayload,
  TemplateForType,
} from "./whatsappTemplate.types";

// Action Types
export const FETCH_WHATSAPP_TEMPLATE_LIST_PROGRESS =
  "FETCH_WHATSAPP_TEMPLATE_LIST_PROGRESS";
export const FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS =
  "FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS";
export const FETCH_WHATSAPP_TEMPLATE_LIST_FAILED =
  "FETCH_WHATSAPP_TEMPLATE_LIST_FAILED";

// Action Creators
export const fetchWhatsAppTemplateListProgress = () =>
  action(FETCH_WHATSAPP_TEMPLATE_LIST_PROGRESS);
export const fetchWhatsAppTemplateListSuccess = (
  data: IWhatsAppTemplate[],
  totalRecords: number
) => action(FETCH_WHATSAPP_TEMPLATE_LIST_SUCCESS, { data, totalRecords });
export const fetchWhatsAppTemplateListFailed = (errorMessage: string) =>
  action(FETCH_WHATSAPP_TEMPLATE_LIST_FAILED);

// Async Actions - Matching fetchMarketingWhatsAppTemplatesListAsync pattern
export const fetchWhatsAppTemplateListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: { fromDate: string; toDate: string },
    searchValue: any[], // IDatatableV2AdvancedSearchFilter
    company_outlet_uuid?: string,
    searchByName?: string,
    searchByTemplateId?: string,
    template_for?: TemplateForType,
    onCallBack?: (data: IWhatsAppTemplate[]) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchWhatsAppTemplateListProgress());
        dispatch(saveLoaderProgress());

        let url = "";

        if (status !== "-1") {
          url += `&status=${status}`;
        }

        if (template_for && template_for !== "-1") {
          url += `&template_for=${template_for}`;
        }
        if (company_outlet_uuid) {
          url += `&company_outlet_uuid=a5d0a2ae-8a50-4331-b601-e350c2a5cbca`;
        }

        if (searchByName) {
          url += `&columns=${JSON.stringify(["name"])}&value=${searchByName}`;
        }

        if (searchValue.length > 0 || searchByTemplateId) {
          const advanceFilter = [...searchValue];

          if (searchByTemplateId) {
            advanceFilter.push({
              column: ["template_id"],
              value: searchByTemplateId,
              logicalOperator: "AND",
              operator: "CONTAINS",
            });
          }

          url += `&advanceFilter=${JSON.stringify(advanceFilter)}`;
        }

        // if (date) {
        //   url += `&from_date=${date.fromDate}&to_date=${date.toDate}`;
        // }

        // Old cursor-based pagination URL (kept for reference)
        // const finalUrl =
        //   `/template/get_whatsapp_template?company_outlet_uuid=${company_outlet_uuid}&itemPerPage=${rowsInPerPage}` +
        //   searchQuery;

        const finalUrl =
          `/template/get-whatsapp-meta-template-by-key?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}` +
          url;

        const res = await whatsappApi.get(finalUrl);

        const data: IWhatsAppTemplate[] = res.data.data;
        const totalRecords = res.data.totalRecords || 0;

        // Old response structure (kept for reference)
        // const data: IWhatsAppTemplate[] = res.data.data.data;
        // const paging = res.data.data.paging;

        dispatch(fetchWhatsAppTemplateListSuccess(data, totalRecords));

        // Execute callback if provided
        if (onCallBack) {
          onCallBack(data);
        }
      } catch (err: any) {
        dispatch(fetchWhatsAppTemplateListFailed(err?.response?.data?.message));
        dispatch(
          showMessage({
            type: "error",
            message: err?.response?.data?.message,
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const FETCH_WHATSAPP_TEMPLATE_PROGRESS =
  "FETCH_WHATSAPP_TEMPLATE_PROGRESS";
export const FETCH_WHATSAPP_TEMPLATE_SUCCESS =
  "FETCH_WHATSAPP_TEMPLATE_SUCCESS";
export const FETCH_WHATSAPP_TEMPLATE_FAILED = "FETCH_WHATSAPP_TEMPLATE_FAILED";

export const fetchWhatsAppTemplateProgress = () =>
  action(FETCH_WHATSAPP_TEMPLATE_PROGRESS);
export const fetchWhatsAppTemplateSuccess = (data: IWhatsAppTemplateData) =>
  action(FETCH_WHATSAPP_TEMPLATE_SUCCESS, { data });
export const fetchWhatsAppTemplateFailed = (errorMessage: string) =>
  action(FETCH_WHATSAPP_TEMPLATE_FAILED, { errorMessage });

export const fetchWhatsAppTemplateAsync =
  (
    templateName?: string,
    companyOutletUuid?: string
    // templateUuid?: string
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(fetchWhatsAppTemplateProgress());

        let url = "";

        if (templateName) {
          url += `&name=${templateName}`;
        }

        // if (templateUuid) {
        //   url += `&whatsapp_template_uuid=${templateUuid}`;
        // }
        const res = await api.get(
          `/template/get-whatsapp-template?company_outlet_uuid=${companyOutletUuid}${url}`
        );
        const data = res.data.data;

        if (data.length > 0) {
          const finalData: IWhatsAppTemplateData = data[0];

          if (companyOutletUuid && companyOutletUuid.trim() !== "") {
            finalData.company_outlet_uuid = companyOutletUuid;
          }

          const result: any = {
            components: [],
            header: {
              type: "HEADER",
              text: "",
              example: {
                header_text: [[]],
              },
            },
            body: {
              type: "BODY",
              text: "",
              example: {
                body_text: [[]],
              },
            },
            buttons: {
              type: "BUTTONS",
              buttons: [],
            },
            footer: {
              type: "FOOTER",
              text: "",
            },
          };

          for (const data of finalData.components) {
            if (data.type === "HEADER") {
              result.header.text = data.text;
              result.header.example = data.example;
            } else if (data.type === "BODY") {
              result.body.text = data.text;
            } else if (data.type === "BUTTONS") {
              result.buttons.buttons = data.buttons as any;
            } else if (data.type === "FOOTER") {
              result.footer.text = data.text;
            }
          }
          finalData.header = result.header;
          finalData.body = result.body;
          finalData.footer = result.footer;
          finalData.buttons = result.buttons;
          finalData.example = {
            body_text:
              result.body.example &&
                result.body.example.body_text &&
                result.body.example.body_text.length > 0
                ? result.body.example.body_text[0]
                : [],
            header_text:
              result.header.example &&
                result.header.example.header_text &&
                result.header.example.header_text.length > 0
                ? result.header.example.header_text[0]
                : [],
          };

          dispatch(fetchWhatsAppTemplateSuccess(finalData));
        } else {
          dispatch(
            fetchWhatsAppTemplateFailed(
              "Unfortunately, there are no records available at the moment."
            )
          );
        }
      } catch (err: any) {
        dispatch(fetchWhatsAppTemplateFailed("Something went to be wrong!"));
        dispatch(
          showMessage({
            type: "error",
            message: err.response.data.message,
            displayAs: "snackbar",
          })
        );
      }
    };

export const upsertWhatsAppTemplate =
  (
    data: IWhatsAppTemplateData,
    onCallBack: (
      isSuccess?: boolean,
      templateData?: IWhatsAppTemplateData
    ) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());

        const finalBody = { ...data.body };

        const finalData: IWhatsAppTemplatePayload = {
          name: data.name.toLowerCase(),

          components: [],

          waba_id: data.waba_id,
          company_outlet_uuid: data.company_outlet_uuid,
          language: "en",
          // category: "MARKETING",
          category: data.category,
          template_for:
            data.template_for && data.template_for.length > 0
              ? (data.template_for.filter((tf) => tf !== "") as TemplateForType[])
              : undefined,
        };

        // Create array of components in correct order
        const components: any[] = [];

        // Add body component
        // Add body component
        if (finalBody.text) {
          const bodyComponent: any = {
            type: "BODY",
            text: finalBody.text,
          };
          // Only add example.body_text if it has values (not [[]], not empty)
          const bodyTextExample =
            finalBody.example &&
              Array.isArray(finalBody.example.body_text) &&
              finalBody.example.body_text.length > 0 &&
              Array.isArray(finalBody.example.body_text[0]) &&
              finalBody.example.body_text[0].length > 0 &&
              finalBody.example.body_text[0].some(
                (v: string) => v && v.trim() !== ""
              )
              ? finalBody.example.body_text
              : undefined;

          if (bodyTextExample) {
            bodyComponent.example = { body_text: bodyTextExample };
          }
          components.push(bodyComponent);
        }

        // Add header component with media if present or if format is LOCATION
        if (
          (data.header.text && data.header.text.length > 0) ||
          (data?.header?.example?.header_handle &&
            data?.header?.example?.header_handle?.length > 0) ||
          data?.header?.format === "LOCATION"
        ) {
          const { paths } = await uploadMultipleFile(
            data?.header?.example?.header_handle || [],
            "WHATSAPP_TEMPLATE",
            { title: data.name }
          );

          const headerComponent: any = {
            type: "HEADER",
          };

          // Only add format if it exists
          if (data.header.format) {
            headerComponent.format = data.header.format;
          }

          // Only add text if it exists
          if (data.header.text) {
            headerComponent.text = data.header.text;
          }

          // Only add example if there are paths
          if (paths && paths.length > 0) {
            headerComponent.example = {
              header_handle: paths?.map((path) => `${path}`),
            };
          }

          components.push(headerComponent);
        }

        /////////////////////
        // Add footer if present and has text
        if (data.footer.text && data.footer.text.length > 0) {
          components.push({
            type: "FOOTER",
            text: data.footer.text,
          });
        }

        // Add buttons if present and has buttons
        if (data.buttons.buttons && data.buttons.buttons.length > 0) {
          components.push({
            type: "BUTTONS",
            buttons: data.buttons.buttons,
          });
        }

        finalData.components = components;

        // const res = await api.post(
        //   "/template/create-whatsapp-meta-template",
        //   finalData
        // );

        const res = await api.post(
          "/template/create-whatsapp-meta-template",
          data.status === "INACTIVE"
            ? { ...finalData, status: "INACTIVE" }
            : finalData
        );

        const templateData = res.data.data;
        dispatch(
          showMessage({
            type: "success",
            message:
              data.status === "INACTIVE"
                ? "WhatsApp template is deleted successfully"
                : data.whatsapp_template_uuid
                  ? "WhatsApp template is updated successfully"
                  : "WhatsApp template is created successfully",
            displayAs: "snackbar",
          })
        );
        onCallBack(true, templateData);
      } catch (err: any) {
        onCallBack(false, undefined);
        dispatch(
          showMessage({
            type: "error",
            message:
              JSON.stringify(err?.response?.data) ||
              "Something went to be wrong!",
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const deleteWhatsAppTemplate =
  (
    company_outlet_uuid: string,
    name: string,
    onCallBack: (isSuccess?: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());

        await api.post(`/template/delete-template`, {
          company_outlet_uuid,
          name,
        });
        dispatch(
          showMessage({
            type: "success",
            message: "WhatsApp template is deleted successfully",
            displayAs: "snackbar",
          })
        );
        onCallBack(true);
      } catch (err: any) {
        onCallBack(false);
        dispatch(
          showMessage({
            type: "error",
            message: JSON.stringify(err.response.data),
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const syncMetaTemplates =
  (
    company_outlet_uuid: string,
    onCallBack?: (isSuccess?: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch, getState) => {
      try {
        dispatch(saveLoaderProgress());
        await api.post(`/template/convert-database-template-to-meta-template`, {
          company_outlet_uuid,
        });
        dispatch(
          showMessage({
            type: "success",
            message: "Meta templates are synced successfully",
            displayAs: "snackbar",
          })
        );
        onCallBack?.(true);
      } catch (err: any) {
        onCallBack?.(false);
        dispatch(
          showMessage({
            type: "error",
            message: JSON.stringify(err.response.data),
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };

export const CLEAR_WHATSAPP_TEMPLATE_STATE = "CLEAR_WHATSAPP_TEMPLATE_STATE";
export const CLEAR_WHATSAPP_TEMPLATE = "CLEAR_WHATSAPP_TEMPLATE";

export const clearWhatsAppTemplateState = () =>
  action(CLEAR_WHATSAPP_TEMPLATE_STATE);
export const clearWhatsAppTemplate = () => action(CLEAR_WHATSAPP_TEMPLATE);

// Assign Template For Action
export const assignTemplateFor =
  (
    name: string,
    company_outlet_uuid: string,
    template_for: string[],
    onCallBack: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
      try {
        dispatch(saveLoaderProgress());

        await api.post(`/template/assign-template-for`, {
          name,
          company_outlet_uuid,
          template_for,
        });

        dispatch(
          showMessage({
            type: "success",
            message: "Template assigned successfully",
            displayAs: "snackbar",
          })
        );
        onCallBack(true);
      } catch (err: any) {
        onCallBack(false);
        dispatch(
          showMessage({
            type: "error",
            message: err?.response?.data?.message || "Something went wrong!",
            displayAs: "snackbar",
          })
        );
      } finally {
        dispatch(saveLoaderCompleted());
      }
    };
